<template>
  <div class="home">
    <div class="section-background section-background-hero">
      <div class="hero-home">
        <div class="text">
          <div>
            <p class="sub-title">
              Develop high performing players
            </p>
            <h1 class="title">
              Embrace. Empower. Elevate.
            </h1>
            <p class="intro">
              <!-- We drive performance of cricket teams and athletes from anywhere
              at anytime using any device. -->
              <!-- We help cricket clubs and academies to digitise their coaching, learning and administration process using smart tools and a centralised platform accessible via iOS, Android and Web apps.
               -->
              Increase your coaching efficiency by 5x using the most 
              time-efficient video analysis platform in the world powered by 
              Artificial Intelligence. 
              <br><br>
              By embracing Ludimos, you empower your players and elevate their skills.
            </p>
            <!-- <p>
              Oh and, we are the world’s first cricket platform to use
              Artificial Intelligence to assist coaches and players.
            </p> -->
            <div class="text-center-mobile flex">
              <a
                class="primary-button primary with-icon"
                @click="openDemoRequest"
              >Request coaching Account</a>
              <b-button
                id="show-btn"
                class="secondary-button secondary"
                @click="openVideoModal"
              >
                Watch video
              </b-button>

              <b-modal
                id="bv-modal-example"
                size="xl"
                hide-footer
                hide-header
                cancel-disabled
                ok-disabled
                centered
              >
                <div>
                  <b-embed
                    type="iframe"
                    aspect="16by9"
                    src="https://www.youtube.com/embed/Nk6Hnw-OrEE?autoplay=1"
                    allowfullscreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  />
                </div>
                <b-button
                  class="close-modal"
                  block
                  @click="$bvModal.hide('bv-modal-example')"
                >
                  <span class="material-icons">
                    close
                  </span>
                </b-button>
              </b-modal>
            </div>
          </div>
        </div>
        <div class="image">
          <img
            src="../assets/img/image-hero.jpg"
            alt="background visual"
          >
        </div>
        <img
          class="graph-image"
          src="../assets/img/hero-graph.png"
          alt="hero graph"
        >
      </div>
    </div>

    <div class="section-background primary auto-height">
      <div class="container">
        <h2 class="title">
          <span>Renowned organisations across the globe trust Ludimos</span>
          Our customers
        </h2>
        <div class="customers-logos">
          <b-carousel
            id="carousel-2"
            :interval="50000"
            indicators
          >
            <b-carousel-slide>
              <template v-slot:img>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/kncb.png"
                    alt="KNCB"
                  >
                  <div class="more-info-block">
                    KNCB <br>
                    The Netherlands
                  </div>
                </div>

                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/cricket-denmark.jpg"
                    alt="cricket denmark"
                  >
                  <div class="more-info-block">
                    Danish Cricket Federation <br>
                    Denmark
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/cricket-argentina.jpg"
                    alt="cricket argentina"
                  >
                  <div class="more-info-block">
                    Argentine Cricket Association <br>
                    Argentina
                  </div>
                </div>

                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/cs-square.jpg"
                    alt="Cricket Serbia"
                  >
                  <div class="more-info-block">
                    Serbian Cricket Association <br>
                    Serbia
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/titans.jpg"
                    alt="The titans"
                  >
                  <div class="more-info-block">
                    The Titans <br>
                    South Africa
                  </div>
                </div>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template v-slot:img>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Callander-Cricket-Club.png"
                    alt="Callander Cricket Club"
                  >
                  <div class="more-info-block">
                    Callander Cricket Club <br>
                    Scotland
                  </div>
                </div>

                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/DJ-Coaching.png"
                    alt="DJ Coaching"
                  >
                  <div class="more-info-block">
                    DJ Coaching <br>
                    South Africa
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Ilkley-Cricket-Club.png"
                    alt="Ilkley Cricket Club"
                  >
                  <div class="more-info-block">
                    Ilkley Cricket Club <br>
                    England
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Spin-Bowling-Academy.png"
                    alt="Spin Bowling Academy"
                  >
                  <div class="more-info-block">
                    Spin Bowling Academy <br>
                    Australia
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/The-Cricket-Academy.png"
                    alt="The Cricket Academy"
                  >
                  <div class="more-info-block">
                    The Cricket Academy <br>
                    South Africa
                  </div>
                </div>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template v-slot:img>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Amsterdam-Cricket-Academy.png"
                    alt="Amsterdam Cricket Academy"
                  >
                  <div class="more-info-block">
                    Amsterdam Cricket Academy
                    <br>
                    The Netherlands
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Claremont-School.png"
                    alt="Claremont School"
                  >
                  <div class="more-info-block">
                    Claremont School <br>
                    England
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Concordia-Cricket-Delft.png"
                    alt="Concordia Cricket Delft"
                  >
                  <div class="more-info-block">
                    Concordia Cricket Delft <br>
                    The Netherlands
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/vra-cricket.png"
                    alt="VRA cricket"
                  >
                  <div class="more-info-block">
                    VRA Cricket <br>
                    The Netherlands
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/redback.png"
                    alt="Redbacks"
                  >
                  <div class="more-info-block">
                    Redbacks <br>
                    Singapore
                  </div>
                </div>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template v-slot:img>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Cutting-Edge-Coaching.png"
                    alt="Cutting Edge Coaching"
                  >
                  <div class="more-info-block">
                    Cutting Edge Coaching <br>
                    England
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Cricket-Club-Bloemendaal.png"
                    alt="Cricket Club Bloemendaal"
                  >
                  <div class="more-info-block">
                    Cricket Club Bloemendaal <br>
                    The Netherlands
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/Cricket-Mentoring.png"
                    alt="Cricket Mentoring"
                  >
                  <div class="more-info-block">
                    Cricket Mentoring <br>
                    Australia
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/fica-germany.jpg"
                    alt="Frankfurt International Cricket Academy"
                  >
                  <div class="more-info-block">
                    Frankfurt International Cricket Academy <br>
                    Germany
                  </div>
                </div>
                <div class="small-card default-card more-info-block-toggler">
                  <img
                    src="../assets/img/B3-Cricket.png"
                    alt="B3 Cricket"
                  >
                  <div class="more-info-block">
                    B3 Cricket <br>
                    England
                  </div>
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </div>

    <div class="section-background auto-height">
      <div class="container">
        <h2 class="title text-center">
          <span>Your coaching needs under one platform</span>
          What we offer
        </h2>
        <div class="our-solution">
          <b-tabs @input="tabChanged">
            <b-tab
              lazy
              active
            >
              <template v-slot:title>
                <div class="title">
                  <p>Ludimos AI</p>
                  <span>Watch only actions that are relevant for coaching. Simply
                    turn on our Ludimos AI to save 80% of video review
                    time</span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/ai-ios.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>
            <b-tab lazy>
              <template v-slot:title>
                <div class="title">
                  <p>Drills and Assignment</p>
                  <span>
                    Create your own drills library or browse our public library
                    of drills for inspiration. Use drills to show your players
                    visually how to practice properly
                  </span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/drills.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>

            <b-tab lazy>
              <template v-slot:title>
                <div class="title">
                  <p>Player & group Management</p>
                  <span>Create unlimited digital groups and manage access for coaches,
                    players and parents by using our Role-Based Access Control
                    (RBAC)</span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/team-management.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>

            <b-tab lazy>
              <template v-slot:title>
                <div class="title">
                  <p>Central and Synchronised</p>
                  <span>Access Ludimos from anywhere using any device at anytime.
                    Coaching information and player profiles are stored
                    centrally for easy access</span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/devices.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>
            <b-tab lazy>
              <template v-slot:title>
                <div class="title">
                  <p>video analysis tools</p>
                  <span>Powerful combination of adding feedback and drills to any
                    video frame. Use frame-by-frame and slow-mo options to
                    analyse videos in detail <br><br>
                    Use text, drawing and audio feedback to communicate with
                    players</span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/feedback-ios.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>
            <b-tab lazy>
              <template v-slot:title>
                <div class="title">
                  <p>Player performance</p>
                  <span>Simply add scores from cricket matches to keep track of
                    progress and correlation with training efforts for a better
                    impact and learning. <br><br>
                    Coaches can design tailored development plans for players
                    based on performances
                  </span>
                </div>
              </template>
              <div class="content">
                <video
                  autoplay
                  muted
                  loop
                >
                  <source
                    src="../assets/img/performance.mp4"
                    type="video/mp4"
                  >
                  Your browser does not support the video tag.
                </video>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <div class="section-background primary wave-bottom wave-top auto-height">
      <div class="container">
        <h2 class="title">
          <span>Your path to inspiring and impactful coaching</span>
          Your benefits
        </h2>
        <!-- <p>
          Discover what is possible when you add Artificial Intelligence and
          advanced video technology to your cricketing activities.
        </p> -->
        <div class="benefits">
          <div class="row">
            <!-- <div class="col-xs-12 col-md-6">
              <div class="default-card flex">
                <div class="content">
                  <div class="title">
                    For clubs
                  </div>
                  <ul class="usp-list">
                    <li>
                      Scout and nurture new talent for sustained growth
                    </li>
                    <li>
                      Retain players by keeping them engaged and active
                    </li>
                    <li>
                      Equip your coaches and players with the right tools
                    </li>
                  </ul>
                </div>
                <div class="image">
                  <img
                    src="../assets/img/club-image.jpg"
                    alt="The Cricket Academy"
                  >
                </div>
              </div>
            </div> -->
            <div class="col-xs-12 col-md-6">
              <div class="default-card flex">
                <div class="content">
                  <div class="title">
                    As a coach
                  </div>
                  <ul class="usp-list">
                    <li>
                      Increased impact in your coaching process. 
                    </li>
                    <li>
                      Create and share your own library of cricketing drills.
                    </li>
                    <li>
                      Measure and track player progress over time.
                    </li>
                  </ul>
                </div>
                <div class="image">
                  <img
                    src="../assets/img/coach-image.jpg"
                    alt="Coach"
                  >
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="default-card flex">
                <div class="content">
                  <div class="title">
                    As a player
                  </div>
                  <ul class="usp-list">
                    <li>
                      Develop new skills faster by learning smarter. 
                    </li>
                    <li>
                      A digital diary documenting your development process.
                    </li>
                    <li>
                      Learn cricket in a fun and interactive way.
                    </li>
                  </ul>
                </div>
                <div class="image">
                  <img
                    src="../assets/img/player-image.jpg"
                    alt="Player"
                  >
                </div>
              </div>
            </div>
            <!-- <div class="col-xs-12 col-md-6">
              <div class="default-card flex">
                <div class="content">
                  <div class="title">
                    For parents
                  </div>
                  <ul class="usp-list">
                    <li>
                      Follow the progress of your child in real-time
                    </li>
                    <li>
                      Learn the game together with your child
                    </li>
                    <li>
                      Assist your child for maximum impact
                    </li>
                  </ul>
                </div>
                <div class="image">
                  <img
                    src="../assets/img/parents-image.jpg"
                    alt="Parents"
                  >
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="section-background padding-xl auto-height">
      <div class="container">
        <h2 class="title text-center">
          <span>Hear directly from our happy users</span>
          User testimonials
        </h2>
        <div class="row">
          <div class="col-xs-12 col-md-5">
            <div class="customer-feedback default-card feedback-video">
              <b-carousel
                id="carousel-2"
                :interval="50000"
                indicators
              >
                <b-carousel-slide>
                  <template v-slot:img>
                    <div class="feedback">
                      <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/Z4oqUrjkCTM"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      />
                    </div>
                    <div class="image flex">
                      <img
                        src="../assets/img/dave-nosworthy.jpg"
                        alt="dave nosworthy"
                      >
                      <p>
                        <b>Dave Nosworthy</b>
                        <i>South African former cricketer</i>
                      </p>
                    </div>
                  </template>
                </b-carousel-slide>

                <b-carousel-slide lazy>
                  <template v-slot:img>
                    <div class="feedback">
                      <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/0rfi8Phc_-I?start=5"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      />
                    </div>
                    <div class="image flex">
                      <img
                        src="../assets/img/noah.jpg"
                        alt="Noah de Roos"
                      >
                      <p>
                        <b>Noah de Roos</b>
                        <i>Player at Bloemendaal CC</i>
                      </p>
                    </div>
                  </template>
                </b-carousel-slide>
                <b-carousel-slide lazy>
                  <template v-slot:img>
                    <div class="feedback">
                      <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/JjQqvrqoDUw?start=5"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      />
                    </div>
                    <div class="image flex">
                      <img
                        src="../assets/img/ashton.jpg"
                        alt="Ashton Charles"
                      >
                      <p>
                        <b>Ashton Charles</b>
                        <i>Cricket player</i>
                      </p>
                    </div>
                  </template>
                </b-carousel-slide>
              </b-carousel>
            </div>
          </div>
          <div class="col">
            <div class="customer-feedback default-card">
              <div class="feedback">
                <p class="main-feedback">
                  Ludimos has been fantastic to use in our online simple batting
                  process.
                </p>
              </div>
              <div class="image flex">
                <img
                  src="../assets/img/gio.jpg"
                  alt="giovanni colussi"
                >
                <p>
                  <b>Giovanni Colussi</b>
                  <i>Director, The Cricket Academy (TCA)</i>
                </p>
              </div>
            </div>
            <div class="customer-feedback default-card">
              <div class="feedback">
                <p class="main-feedback">
                  Truly maximises the return on our cricket training activities.
                </p>
              </div>
              <div class="image flex">
                <img
                  src="../assets/img/tammo-beishuizen.jpg"
                  alt="tammo beishuizen"
                >
                <p>
                  <b>Tammo Beishuizen</b>
                  <i>Chairman, Cricket Club Bloemendaal</i>
                </p>
              </div>
            </div>
            <div class="customer-feedback default-card">
              <div class="feedback">
                <p class="main-feedback">
                  Ludimos is a fantastic tool to analyse player performances.
                </p>
              </div>
              <div class="image flex">
                <img
                  src="../assets/img/sam.jpg"
                  alt="sanjay patel"
                >
                <p>
                  <b>Sam Lavery</b>
                  <i>Bowling Coach - Womens 1st XI / Boys Pathway @ Surrey
                    County Cricket Club</i>
                </p>
              </div>
            </div>
            <div class="customer-feedback default-card">
              <div class="feedback">
                <p class="main-feedback">
                  Players are more likely to correct their technique when they
                  see it.
                </p>
              </div>
              <div class="image flex">
                <img
                  src="../assets/img/sanjay-patel-1.jpg"
                  alt="sanjay patel"
                >
                <p>
                  <b>Sanjay Patel</b>
                  <i>Director of Cricket @ Mill Hill School, 1st XI Coach @
                    Middlesex CCC women’s</i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-background primary padding-xs auto-height">
      <div class="container">
        <h2 class="title">
          <span>Are you an individual wanting to improve your own game?</span>
          Hire your coach from our marketplace
        </h2>
        <div class="marketplace">
          <div class="row">
            <div class="col">
              <p>
                We have a selection of high quality coaches from around the
                world who can help you improve your game. Simply book a coach,
                upload your videos and receive feedback.
              </p>
              <a
                class="primary-button white with-icon"
                target="_blank"
                @click="goToMP"
              >
                Go to marketplace
              </a>
            </div>
            <div class="col image">
              <img
                src="../assets/img/marketplace.png"
                alt="ludimos marketplace"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-background padding-xl auto-height">
      <div class="container">
        <!-- <div class="latest-news">
          <h2 class="title text-center">
            <span>Our headlines</span>
            Latest news
          </h2>
          <div class="row">
            <div class="col-sm-12 col-md-3">
              <a
                href="release/cricket-serbia-joins-ludimos-family"
                class="blog-container"
              >
                <img
                  class="img-fluid"
                  src="../assets/img/cs-square.jpg"
                  alt="Cricket Serbia"
                >
                <div class="blog-body">
                  <h3>
                    Cricket Serbia joins Ludimos Family 
                  </h3>
                  <div class="date-author">
                    Ludimos team | Mar 10, 2021
                  </div>
                </div>
              </a>
            </div>
            <div class="col-sm-12 col-md-3">
              <a
                href="release/cricket-argentina-joins-ludimos-family"
                class="blog-container"
              >
                <img
                  class="img-fluid"
                  src="../assets/img/ca-square.jpg"
                  alt="Cricket Argentina"
                >
                <div class="blog-body">
                  <h3>
                    Cricket Argentina joins Ludimos Family
                  </h3>
                  <div class="date-author">
                    Ludimos team | Dec 12, 2020
                  </div>
                </div>
              </a>
            </div>

            <div class="col-sm-12 col-md-3">
              <a
                href="release/ludimos-brings-in-german-cricket-academys-head-coach-as-its-advisor"
                class="blog-container"
              >
                <img
                  class="img-fluid"
                  src="../assets/img/abhijit-khan.jpg"
                  alt="Abhijit Khan"
                >
                <div class="blog-body">
                  <div class="title">
                    <h3>
                      Ludimos brings in German Cricket Academy's Head coach as
                      its Advisor
                    </h3>
                  </div>
                  <div class="date-author">
                    Ludimos team | Aug 26, 2020
                  </div>
                </div>
              </a>
            </div>
            <div class="col-sm-12 col-md-3">
              <a
                href="release/ludimos-goes-into-bat-with-northerns-on-cricket-development"
                class="blog-container"
              >
                <img
                  class="img-fluid"
                  src="../assets/img/titans.jpg"
                  alt="Titans"
                >
                <div class="blog-body">
                  <div class="title">
                    <h3>
                      Ludimos goes into bat with northerns on cricket
                      development
                    </h3>
                  </div>
                  <div class="date-author">
                    Ludimos team | Aug 21, 2020
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div> -->

        <h3 class="title text-center">
          Ludimos was featured in
        </h3>
        <div class="press-logos">
          <div class="default-card more-info-block-toggler">
            <a href="/release/ludimos-technology-featured-in-cgtn">
              <img
                src="../assets/img/CGTN-africa.jpg"
                alt="CGTN africa"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
          <div class="default-card more-info-block-toggler">
            <a
              target="_blank"
              href="https://timesofindia.indiatimes.com/sports/cricket/news/chennai-techie-comes-up-with-ai-based-online-cricket-coaching/articleshow/74792867.cms"
            >
              <img
                src="../assets/img/times-of-india.jpg"
                alt="times of india"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
          <div class="default-card more-info-block-toggler">
            <a
              target="_blank"
              href="https://sportageous.co/ludimos-cricket-coaching-made-easy-with-founder-madan-rajagopal/"
            >
              <img
                src="../assets/img/sportageous.jpg"
                alt="sportageous"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
          <div class="default-card more-info-block-toggler">
            <a
              target="_blank"
              href="https://www.news18.com/cricketnext/news/how-cricket-camps-are-taking-the-online-route-in-times-of-coronavirus-2572177.html"
            >
              <img
                src="../assets/img/cricket-next.jpg"
                alt="cricket next"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
          <div class="default-card more-info-block-toggler">
            <a
              target="_blank"
              href="https://www.sportknowhowxl.nl/achtergronden/sport-knowhow-xl-news--in-english-/item/120421/startup-ludimos-helps-cricket-players-with-intensive-coaching"
            >
              <img
                src="../assets/img/sportknowhowxl.jpg"
                alt="sportknowhow"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
          <div class="default-card more-info-block-toggler">
            <a
              target="_blank"
              href="https://sportstar.thehindu.com/cricket/ludimos-online-coaching-platform-vidyutsivaramakrishnan-davidnosworthy-covid-19/article31274191.ece"
            >
              <img
                src="../assets/img/sportstar.jpg"
                alt="sportstar"
              >
              <div class="more-info-block">Read article</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Home",
      action: "Home",
      label: "Home",
      type: "Home",
    });
  },
  methods: {
    openVideoModal() {
      this.$bvModal.show("bv-modal-example");
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Video Click",
        label: "Explainer Video",
        type: "Explainer Video",
      });
    },

    goToClub() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Clubs Click",
        label: "Learn more - clubs",
        type: "Learn more - clubs",
      });
      this.$router.push({ name: "clubs" });
    },
    openDemoRequest() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Request Demo",
        label: "First Page",
        type: "First Page",
      });
      this.$router.push({ name: "request-demo" });
      //  window.open(
      //   `${process.env.VUE_APP_APP_BASE_URL}/register-club?utm_source=website&utm_medium=banner`
      // );
    },
    trackAndroidClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Android Click",
        label: "Android Click",
        type: "Android Click",
      });
    },
    trackIOSClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "IOS Click",
        label: "IOS Click",
        type: "IOS Click",
      });
    },
    goToMP() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "MP Click",
        label: "From Home",
        type: "From Home",
      });
      this.$router.push({ name: "coaches" });
    },
    registerClub() {
      this.$ma.trackEvent({
        fb_event: "Home",
        category: "Home",
        action: "Home",
        label: "RgisterClub",
        type: "RgisterClub",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/register-club?utm_source=website&utm_medium=Home`
      );
    },
    signUp() {
      this.$ma.trackEvent({
        fb_event: "Home",
        category: "Home",
        action: "Home",
        label: "Signup",
        type: "Signup",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/sign-up?utm_source=website&utm_medium=Home`
      );
    },
    tabChanged(index) {
      const solutionOrder = [
        "Ludimos AI",
        "Drills and Assignments",
        "Team and Athlete Management",
        "Central and Synchornised",
        "Video Analysis Tools",
        "Player Performance",
      ];

      this.$ma.trackEvent({
        fb_event: "SolutionClick",
        category: "SolutionClick",
        action: solutionOrder[index],
        label: solutionOrder[index],
        type: solutionOrder[index],
      });
    },
  },
  metaInfo() {
    return {
      title: "Ludimos - Catalyst To Your Teams Performance",
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
